// Web module: dashboard (L9 audits, events, dashboard). Owns the "/" route.
// The shell ships a placeholder grid with Drata's widget names (DashboardPage.tsx); the dashboard lane fills it.
// The contract is in ../README.md.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import type { WebModule } from '../../lib/modules'

export const dashboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./DashboardPage'), 'DashboardPage'),
})

export const module: WebModule = {
  routes: [dashboardRoute],
  entityOverrides: {},
}
